import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../lib/api";
import { Card, Tag } from "./bits";

export const UnknownSymbols = () => {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/symbols/unknown").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const set = async (symbol, cls) => { try { const { data } = await api.put(`/admin/symbols/${encodeURIComponent(symbol)}`, { asset_class: cls }); toast.success(`${symbol} → ${cls} (${data.trades_updated} trades updated)`); load(); } catch (e) { toast.error(errText(e)); } };
  if (!d) return null;
  const pending = d.items.filter((x) => !x.resolved);
  return (
    <Card className="mt-4" title="Symbols needing an asset class" sub={`${pending.length} unresolved · unknown symbols default to "Other" until classified here`} testId="unknown-symbols-card">
      {d.items.length === 0 ? <div className="sub">No unknown symbols recorded.</div> : (
        <table className="tbl" data-testid="unknown-symbols-table"><thead><tr><th>Symbol</th><th>Seen</th><th>Source</th><th>Class</th></tr></thead>
          <tbody>{d.items.map((x) => (
            <tr key={x.symbol} data-testid={`unknown-symbol-${x.symbol}`}>
              <td><b>{x.symbol}</b></td><td className="mono">{x.count}</td><td>{x.last_source}</td>
              <td>{x.resolved ? <Tag kind="ok">{x.resolved}</Tag> : <select defaultValue="" onChange={(e) => e.target.value && set(x.symbol, e.target.value)} data-testid={`classify-${x.symbol}`}><option value="">Choose…</option>{d.classes.map((c) => <option key={c} value={c}>{c}</option>)}</select>}</td>
            </tr>))}</tbody></table>)}
    </Card>
  );
};
